import { render, staticRenderFns } from "./SingleBudgetProgramSelection.vue?vue&type=template&id=6f59f886&"
import script from "./SingleBudgetProgramSelection.vue?vue&type=script&lang=ts&"
export * from "./SingleBudgetProgramSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports